import React, { useState } from "react";
import {
  Typography,
  IconButton,
  InputAdornment,
  FormControl,
  InputLabel,
  OutlinedInput,
  Grid,
  Button,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";

function UsernamePasswordPair({
  role,
  label,
  setMessage,
  setUserChanged,
  setErrorMessage,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");

  const { store } = useStateContext();

  const changePassword = () => {
    const regex = /^\d*$/;

    if (regex.test(password)) {
      const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
      const databaseStoreName = `DB301_${
        JSON.parse(store).id
      }_${correctStoreName}`;

      const payload = {
        params: {
          role: role,
          password: password,
          shopName: databaseStoreName,
        },
      };
      axiosClient
        .patch("user/password", payload)
        .then((response) => {
          setErrorMessage("");
          setMessage(response.data.message);
          setUserChanged(role);
        })
        .catch((err) => {
          setMessage("")
          setErrorMessage(err.response.data.err.errors[0].message);
          setUserChanged(role);
        });
    } else {
      setMessage("")
      setUserChanged(role);
      setErrorMessage("The password must contain only numbers!!!!")
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={4} lg={4} sm={4}>
        <Typography variant="body1">{role}</Typography>
      </Grid>
      <Grid item xs={12} md={4} lg={4} sm={4}>
        <FormControl variant="outlined" fullWidth>
          <InputLabel htmlFor={`outlined-adornment-${label}-password`}>
            Password
          </InputLabel>
          <OutlinedInput
            id={`outlined-adornment-${label}-password`}
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={handlePasswordChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleTogglePasswordVisibility}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} md={3} lg={3} sm={3}>
        <Button variant="contained" color="success" onClick={changePassword}>
          Change password
        </Button>
      </Grid>
    </Grid>
  );
}

export default UsernamePasswordPair;
